class Textarea_Validation {
	constructor() {
		this.selectors = {
			document: document,
			textarea: '.js-comment-validate'
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {		
		this.nodes.textarea.keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ0-9.,\s]+$/) ? true : false);
		this.nodes.textarea.bind('copy paste cut', e => e.preventDefault());
    }
}
new Textarea_Validation();